// Visual tokens for the public landing page only. The signed-in app keeps
// its own MUI theme (src/theme); nothing here leaks into it.
export const landing = {
  accent: '#0F766E',
  accentDeep: '#0C5953',
  accentSoft: '#E9F3F2',
  accentSoft2: '#D9E9E8',
  bg: '#FAFAF8',
  bg2: '#F0F3F2',
  surface: '#FFFFFF',
  ink: '#0F1B1F',
  ink2: '#3E4D53',
  ink3: '#5A6A70',
  line: '#DEE4E2',
  chatBg: '#EDF1EF',
  warn: '#B45309',
  shadow:
    '0 1px 2px rgba(15,27,31,.06), 0 18px 40px -18px rgba(15,27,31,.22)',
  display: "'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
  body: "'DM Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
  mono: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  maxWidth: 1200,
};

// The faint dot grid behind the hero and the closing call to action.
export const dotsBackground = {
  backgroundImage:
    'radial-gradient(rgba(15, 27, 31, 0.1) 1px, transparent 1.2px)',
  backgroundSize: '22px 22px',
};

// One color per group member in the demos, each with its 16% tint.
export const people = {
  bruna: { color: '#B45309', tint: '#F3E4D8' },
  diego: { color: '#1D4ED8', tint: '#DBE3F9' },
  ana: { color: '#7E22CE', tint: '#EADCF7' },
};

export { BOT_USERNAME, BOT_URL } from '../../config/telegram';
